import { ComponentProps, FC } from 'react'
import { TextInput } from '../../TextInput'
import { FieldInputs } from '../types'
import { FormController } from './FormController'

export const FormTextInput: FC<
  FieldInputs<string | undefined> & ComponentProps<typeof TextInput>
> = (props) => {
  const { name, onValidate, ...rest } = props
  return (
    <FormController
      name={name}
      onValidate={onValidate}
      render={({ value, onValueChange }) => (
        <TextInput onChange={(e) => onValueChange(e.target.value)} value={value} {...rest} />
      )}
    />
  )
}
